<script setup lang="ts">
import { IconArrowRight, useIsMobile } from '#shared'
import { computed } from 'vue'
import { useFullscreenChatHref } from '#entities/chat'

const mainChatHref = useFullscreenChatHref(import.meta.env.VITE_MAIN_CHAT_ID)

const isMobile = useIsMobile()
const linkLabel = computed(() => {
  if (isMobile.value) return 'Join'
  return 'Join conversations'
})
</script>

<template>
  <header :class="$style.root">
    <div :class="$style.label">Chats</div>
    <a :class="$style.link" :href="mainChatHref">
      {{ linkLabel }}
      <IconArrowRight />
    </a>
  </header>
</template>

<style lang="scss" module>
.root {
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #424348;
  padding: 0 10px;
}

.label {
  font-size: 16px;
  font-weight: 700;
}

.link {
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  color: #397ae9 !important;
  display: flex !important;
  width: fit-content !important;
  align-items: center;
  gap: 4px;
}
</style>
